module.exports = __webpack_public_path__ + "assets/img/bg-6c931f5e.jpg";